module.exports = __webpack_public_path__ + "static/img/close.6a491b2e.png";